import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Serviço responsável por registrar ícones SVG customizados no MatIconRegistry.
 * Os ícones são mapeados para nomes específicos e podem ser usados com mat-icon.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomIconRegistryService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  /**
   * Mapeamento de nomes lógicos para arquivos SVG
   */
  private readonly customIcons = {
    'monitoring-safra': 'Monitoramento da Safra.svg',
    'historic-safra': 'Historico de Safras.svg',
    'compliance-socioambiental': 'Compliance Socioambiental.svg',
    'datasafra-agent': 'datasafra-agent.svg',
  };

  /**
   * Registra todos os ícones SVG customizados no MatIconRegistry.
   * Deve ser chamado na inicialização da aplicação.
   */
  registerIcons(): void {
    const basePath = 'assets/icon';

    Object.entries(this.customIcons).forEach(([iconName, fileName]) => {
      // Codifica o nome do arquivo para tratar espaços e caracteres especiais
      const encodedFileName = encodeURIComponent(fileName);
      const iconPath = `${basePath}/${encodedFileName}`;
      const sanitizedUrl =
        this.sanitizer.bypassSecurityTrustResourceUrl(iconPath);

      // Usa namespace para evitar conflitos de CSS entre SVGs
      this.iconRegistry.addSvgIcon(iconName, sanitizedUrl);
    });
  }
}
